import * as React from 'react';
import px from 'prop-types';
import { useSelector } from 'react-redux';
import { useAction, useProductTabContent } from 'Common/hooks';
import { ProductAccordion as Accordion, ProductDescriptionTab } from 'Common/components/product';
import { customer, product, order } from '~features';
import * as GTM from 'Common/constants/gtm';

export default function ProductAccordion({ className, ...props }) {
    const options = useSelector(product.selectors.getOptions);
    const isUserAuthenticated = useSelector(customer.selectors.isLoggedIn);
    const productInfo = useSelector(product.selectors.getProduct);
    const productDefinitions = useSelector(product.selectors.getProductDefinitions);
    const onAddItemToCart = useAction(order.actions.addItem);
    const orderLastUpdate = useSelector(order.selectors.getLastUpdate);
    const totalQty = useSelector(order.selectors.getTotalQuantity);
    const displayOnly = React.useMemo(() => productInfo?.StockStatus === 'DisplayOnly', [productInfo]);
    const content = useProductTabContent();

    return content?.length ? (
        <Accordion
            className={className}
            content={content}
            DescriptionTab={ProductDescriptionTab}
            gtmListValue={GTM.TAGS.PDP}
            isUserAuthenticated={isUserAuthenticated}
            options={options}
            onAddItemToCart={onAddItemToCart}
            orderLastUpdate={orderLastUpdate}
            productDefinitions={productDefinitions}
            productInfo={productInfo}
            displayOnly={displayOnly}
            totalQty={totalQty}
            {...props}
        />
    ) : null;
}

ProductAccordion.propTypes = {
    className: px.string,
    pageId: px.string,
    specsTableBreakpoint: px.number,
};
